import React from 'react';
import {
  AlertIcon,
  Box,
  BoxExtendedProps,
  LinkButton,
  Text,
} from '@common-fe/common-fe';

interface Props extends BoxExtendedProps {
  handleOpenEditCheckAddressModal: () => void;
}

export const BadAddressWarning: React.FC<Props> = ({ handleOpenEditCheckAddressModal, ...props }) => {
  return (
    <Box
      data-testId="bad-address-warning"
      pad="spacing12"
      border={{ size: 'small', color: 'dangerBorder' }}
      background="dangerContainer"
      round="container2Round"
      direction="row"
      align="center"
      {...props}
    >
      <AlertIcon size="24px" />
      <Box margin={{ left: 'spacing8' }}>
        <Text data-testId="bad-address-warning_title">
          The listed address is flagged as bad address. You must update the address before sending the
          remainder.
        </Text>
        <Box margin={{ top: 'spacing8' }}>
          <LinkButton
            testId="bad-address-warning_edit-address"
            onClick={handleOpenEditCheckAddressModal}
            linkInlineMode
          >
            Edit Address
          </LinkButton>
        </Box>
      </Box>
    </Box>
  );
};
